// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(optional)`
};

const de_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(optional)`
};

const es_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(opcional)`
};

const fr_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(optionnel)`
};

const fi_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(valinnainen)`
};

const hi_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(वैकल्पिक)`
};

const ja_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(任意)`
};

const nl_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(optioneel)`
};

const pt_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(opcional)`
};

const ro_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(opțional)`
};

const th_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(ไม่บังคับ)`
};

const ur_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(اختیاری)`
};

const zh_hant1_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(可選)`
};

const da_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(valgfrit)`
};

const it_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(opzionale)`
};

const vn_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(tùy chọn)`
};

const ko_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(선택사항)`
};

const tr_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(isteğe bağlı)`
};

const lv_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(neobligāts)`
};

const ar_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(اختياري)`
};

const bs_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(neobavezno)`
};

const sl_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(neobvezno)`
};

const id_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(opsional)`
};

const sv_widget_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(valfritt)`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_optional = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_optional(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_optional", locale)
	if (locale === "en") return en_widget_optional(inputs)
	if (locale === "de") return de_widget_optional(inputs)
	if (locale === "es") return es_widget_optional(inputs)
	if (locale === "fr") return fr_widget_optional(inputs)
	if (locale === "fi") return fi_widget_optional(inputs)
	if (locale === "hi") return hi_widget_optional(inputs)
	if (locale === "ja") return ja_widget_optional(inputs)
	if (locale === "nl") return nl_widget_optional(inputs)
	if (locale === "pt") return pt_widget_optional(inputs)
	if (locale === "ro") return ro_widget_optional(inputs)
	if (locale === "th") return th_widget_optional(inputs)
	if (locale === "ur") return ur_widget_optional(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_optional(inputs)
	if (locale === "da") return da_widget_optional(inputs)
	if (locale === "it") return it_widget_optional(inputs)
	if (locale === "vn") return vn_widget_optional(inputs)
	if (locale === "ko") return ko_widget_optional(inputs)
	if (locale === "tr") return tr_widget_optional(inputs)
	if (locale === "lv") return lv_widget_optional(inputs)
	if (locale === "ar") return ar_widget_optional(inputs)
	if (locale === "bs") return bs_widget_optional(inputs)
	if (locale === "sl") return sl_widget_optional(inputs)
	if (locale === "id") return id_widget_optional(inputs)
	if (locale === "sv") return sv_widget_optional(inputs)
	return "widget_optional"
};